<template>
  <div class="page-pay">
    <div class="list-none" v-if="listData.length === 0">
      <img src="../../../assets/list-none.png" alt="" />
      <div>空荡荡的~暂无账单数据！</div>
    </div>

    <div v-else class="main">
      <list-item
        :can-option="canOption"
        v-for="data in listData"
        :data-info="data"
        :key="data.id"
        :first-org-id="firstOrgId"
      >
      </list-item>
    </div>

    <div v-if="canOption" class="footer">
      <div class="footer-content">
        <div></div>
        <div>
          <strong class="footer-content-money">￥{{ moneyStr }}</strong>
          <strong @click="showQR" :class="footerButton">去结算</strong>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListItem from "./ListItem";
import axios from "axios";
import { Loading } from "element-ui";
import wx from "weixin-js-sdk";
import Utils from "../../../Utils";
import { Decimal } from "decimal.js";

export default {
  name: "List",

  components: {
    ListItem
  },

  computed: {
    footerButton() {
      if (this.moneyStr > 0) {
        return "footer-content-commit";
      }
      return "footer-content-commit-1"
    }
  },

  data() {
    return {
      listData: [],
      billIdList: new Set(),
      state: "全部",
      moneyStr: 0,
      canOption: true,
      isLoading: false,
      firstOrgId: ""
    };
  },
 created() {
    let state = this.$route.query.state === "1";

    localStorage.setItem("token", this.$route.query.token || "");
    localStorage.setItem("orgID", this.$route.query.orgID || "");
    localStorage.setItem("type", this.$route.query.client || "");
    console.log(state)
    if (state) {
      this.state = "未支付";
      this.canOption = true;
      document.title = "待缴账单";
    } else {
      this.state = "已支付";
      this.canOption = false;
      document.title = "缴费记录";
    }
    this.query();
  },
  methods: {
    showQR() {
      if (this.isLoading === true) {
        return;
      }
      if (this.billIdList.size === 0) {
        this.$message.error("请选择账单");
        return;
      }
      let url = axios.defaults.baseURL + "bills/pay";
      url = url.replace("org", "users");
      url = url.replace("10241", "10242");

      this.isLoading = true;

      axios({
        method: "post",
        url: url,
        data: {
          billIDs: Array.from(this.billIdList)
        }
      })
        .then(value => {
          if (value.data.code === 0) {
            let data = value.data.data;
            // 微信小程序
            wx.miniProgram.getEnv(function() {
              wx.miniProgram.navigateTo({
                url:
                  "/pages/bills/pay?" +
                  "orderID=" +
                  data.orderID +
                  "&prepayID=" +
                  data.prepayID +
                  "&expiredAt=" +
                  data.expiredAt
              });
            });
          } else {
            this.$message.error(value.data.message);
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isLoading = false;
        });
    },

    //列表查询
    query() {
      let url = axios.defaults.baseURL + "bills";
      url = url.replace("v1/org", "v2/users");
      url = url.replace("10241", "10242");
 
      const loading = Loading.service({
        lock: true,
        text: "加载列表中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.1)"
      });

      axios({
        method: "post",
        url: url,
        data: {
           state:  this.state,
        }
      }).then(value => {
          this.listData = value.data.data;
          if (this.listData.length > 0) {
            this.firstOrgId = this.listData[0].id;
          }
        })
        .catch(() => {})
        .finally(() => {
          loading.close();
        });
    },

    excite() {
      let _vue = this;
      _vue.moneyStr = 0;
      this.listData.forEach(value => {
        value.bills.forEach(value1 => {
          if (_vue.billIdList.has(value1.id)) {
            _vue.moneyStr += value1.totalAmount
          }
        });
      });
      _vue.moneyStr = new Decimal(_vue.moneyStr).div(new Decimal(100)).toNumber()
    }
  },

 
};
</script>

<style scoped lang="scss">
@import "page";

.main {
  margin-bottom: 120px;
}

.footer {
  z-index: 10086;
  width: 100%;
  height: 64px;
  background: white;
  position: fixed;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  .footer-title {
    margin-top: 5px;
    box-sizing: border-box;
    font-size: 12px;
    justify-content: center;
    display: flex;
    width: 100%;
    .footer-title-name {
      color: $colorDefault;
    }
    .footer-title-value {
      text-decoration: line-through;
      margin-left: 10px;
      color: $fontColor-9;
    }
  }
  .footer-content {
    position: absolute;
    bottom: 15px;
    width: 100%;
    margin-top: 5px;
    padding-left: 14px;
    padding-right: 14px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    > div {
      display: flex;
      align-items: center;
    }
    .footer-content-check {
      color: $fontColor-6;
      img {
        margin-right: 5px;
        width: 22px;
        height: 22px;
      }
    }
    .footer-content-money {
      font-size: 24px;
      margin-right: 30px;
      color: #ec5e5d;
    }
    .footer-content-commit {
      font-size: 16px;
      padding: 5px 14px;
      box-sizing: border-box;
      color: white;
      background: #1296db;
      border-radius: 20px;
    }
    .footer-content-commit-1 {
      font-size: 16px;
      padding: 5px 14px;
      box-sizing: border-box;
      color: white;
      background: $bgColor;
      border-radius: 20px;
    }
  }
}
</style>
